module.exports = __webpack_public_path__ + "03_cheeks.7c861ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer3/03_cheeks.png
// module id = EZpq
// module chunks = 0